import * as React from 'react'
import { GDataContext, useProvidedGData } from '../graph/GDataContext';
import { TerminalScoreManager } from './model/TerminalScoreManager';
import { ITerminalScore } from './model/TerminalScore';
import { GDataGraph } from '../graph/GDataGraph';
import SimpleNodeListContext from '../general/SimpleNodeListContext';


export interface ITerminalScoreData {
  terminalScore?: TerminalScoreManager,
  graph?: GDataGraph,
  hasError: boolean
}


export const TerminalScoreContext = React.createContext<ITerminalScoreData>({
  hasError: false
});

type Props = {
  children: any,
}


const TerminalScoreProvider = ({
  children,
}: Props) => {
  const graph = useProvidedGData();
  const simpelNodeContext = React.useContext(SimpleNodeListContext);
  const [data, setDate] = React.useState<ITerminalScore>(undefined);
  const [hasError, setHasError] = React.useState<boolean>(false);
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);

  async function downloadScore() {
    /**
     * Try brotli compression first. If it doesn't work try gzip.
     */
    try {
      const res = await fetch('https://storage.googleapis.com/lnrouter-public/lnrouter.app/terminal_score.json');
      const json = await res.json();
      return json;
    } catch (e) {
      const res = await fetch('https://storage.googleapis.com/lnrouter-public/lnrouter.app/terminal_score.json.gzip');
      const json = await res.json();
      return json;
    }


  }

  async function fetchData() {
    try {
      setHasError(false);
      const json = await downloadScore();
      setDate(json);

    } catch (e) {
      console.error(e);
      setHasError(true);
    }

  }

  React.useEffect(() => {

    if (data && graph?.dataset && simpelNodeContext.nodes) {
      setIsLoaded(true);
    }
  }, [data, graph, SimpleNodeListContext]);

  React.useEffect(() => {
    if (!data) {
      fetchData();
    }
  }, [])


  let context: ITerminalScoreData = {
    hasError: hasError
  };
  if (isLoaded) {
    context = {
      terminalScore: new TerminalScoreManager(data),
      graph: new GDataGraph(graph.dataset),
      hasError: hasError
    };
  }

  return (
    <TerminalScoreContext.Provider value={context}>
      {children}
    </TerminalScoreContext.Provider>
  );
};

export default TerminalScoreProvider;